module.exports = __webpack_public_path__ + "img/sd-ob2.a7ed643b.svg";